
import { defineComponent, PropType } from 'vue'

type OkTableRow = Record<string, any>
type OkTableColumn = Record<string, any>

export default defineComponent({
    props: {
        rows: {
            type: Array as PropType<OkTableRow[]>,
            default: () => [],
        },
        columns: {
            type: Array as PropType<OkTableColumn[]>,
            default: () => [],
        },
        clickableRow: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['row-click'],
    setup(props, { emit }) {
        const onRowClick = (row: OkTableRow) => {
            if (!props.clickableRow) return
            emit('row-click', row)
        }

        return {
            onRowClick,
        }
    },
})
